import style from './style.module.scss'

export const LogoCat = ({showText} : {showText?: boolean}) => {
    return (
        <>
            <div className={`${style.logo_wrapper} ${!showText ? style.showText : ''}`}>
                <div className={style.logo_image_wrapper}>
                    <div className={style.logo_image} />
                </div>
                <div className={style.text}>
                    SAVE THE CAT!
                </div>
            </div>
        </>
    );
}